import { createFileRoute, notFound, useParams } from "@tanstack/react-router";
import { EventPage } from "@/components/activity/event-page";
import { parseEventId } from "@/lib/event-path";
import { pruneSearch } from "@/lib/router-search";

/**
 * Keep the event host mounted when a param write selects an explicit view.
 * The event id names its supersede lineage, so old permalinks still land.
 */
export const Route = createFileRoute("/$owner/events/$eventId")({
	beforeLoad: ({ params }) => {
		if (parseEventId(params.eventId) === null) throw notFound();
	},
	component: EventRoutePage,
	validateSearch: (search: Record<string, unknown>) =>
		pruneSearch(search) as Record<string, string | undefined>,
});

function EventRoutePage() {
	const { owner, eventId } = Route.useParams();
	const view = useParams({
		from: "/$owner/events/$eventId/-/views/$viewKey",
		shouldThrow: false,
	});
	const id = parseEventId(eventId);
	if (id === null) return null;
	return <EventPage owner={owner} eventId={id} viewKey={view?.viewKey} />;
}
